import React from 'react';

const EmailTemplates = () => {
    return (
        <div>Email Templates Content</div>
    );
};

export default EmailTemplates;